export const numberToCurrency = (value: number, minDigits: number = 2, maxDigits: number = 2) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    currencyDisplay: 'narrowSymbol',
    maximumFractionDigits: maxDigits,
    minimumFractionDigits: minDigits
  }).format(value)
}

export const numberToSimple = (value: number, maxDigits: number = 3) => {
  return new Intl.NumberFormat('en-US', {
    maximumSignificantDigits: maxDigits
  }).format(value)
}